import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const defaultSettings = {
  isBoardMoreObvious: false,
  isOverElementAutoScrollEnabled: true,
  boardScrollSpeed: 'fast',
  columnScrollSpeed: 'standard',
  isFPSPanelEnabled: false,
  isCPUBurnEnabled: false,
  isOverflowScrollingEnabled: true,
};

const fields = {
  isBoardMoreObvious: {
    type: 'boolean',
    title: 'Make board more obvious',
    description: 'Add extra spacing and borders to the board scroll container to make it easier to see and play with',
  },
  isFPSPanelEnabled: {
    type: 'boolean',
    title: 'FPS Panel',
    description: 'Display a panel with Frame Per Second (FPS) information',
  },
  isCPUBurnEnabled: {
    type: 'boolean',
    title: 'Drop FPS 🔥',
    description: 'Start heavy process that will cause the frame rate on the page to drop',
  },
  isOverElementAutoScrollEnabled: {
    type: 'boolean',
    title: 'Over element auto scrolling',
    description: 'Should elements automatically scroll when over them',
  },
  isOverflowScrollingEnabled: {
    type: 'boolean',
    title: 'Overflow scrolling',
    description: 'Should overflow scrolling be enabled',
  },
  boardScrollSpeed: {
    type: 'select',
    title: 'Board auto scroll speed',
    description: 'What should the max horizontal scroll speed the board be?',
    options: ['fast', 'standard'],
  },
  columnScrollSpeed: {
    type: 'select',
    title: 'Column auto scroll speed',
    description: 'What should the max vertical scroll speed for columns be?',
    options: ['fast', 'standard'],
  },
};

export const SettingsContext = createContext({
  fields,
  settings: defaultSettings,
  update: () => {},
  reset: () => {},
});

export function SettingsContextProvider({ children }) {
  const [settings, setSettings] = useState(defaultSettings);

  const value = useMemo(() => {
    function update(partial) {
      const updated = { ...settings, ...partial };
      setSettings(updated);
    }

    return {
      fields,
      settings,
      update,
      reset: () => update(defaultSettings),
    };
  }, [settings]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

SettingsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
